<script>
	import {_} from "svelte-i18n"
	import { previews_are_highlighted, text_previewed, text_caseapplied } from './../stores.js'
	import Button from "../elements/Button.svelte"

	const handleClearHighlight = () => {
		$previews_are_highlighted = false
		$text_previewed = $text_caseapplied;
	}
</script>

<Button kind="outline" size="small" on:click={handleClearHighlight} >
	{$_('buttons.clearHighlight')}
</Button>